import { VoiceApiEndpoints } from "../apiEndpoints";
import { fetchData } from "../apiHelpers";
import { buildVoiceUrl } from "../voiceApi";
import { CallMessageRow, CallRow } from "./call.types";

export type CallsListParams = {
  limit?: number;
  offset?: number;
};

export async function getCalls(
  params: CallsListParams = {}
): Promise<CallRow[]> {
  const searchParams = new URLSearchParams();

  if (typeof params.limit === "number") {
    searchParams.set("limit", String(params.limit));
  }

  if (typeof params.offset === "number") {
    searchParams.set("offset", String(params.offset));
  }

  const query = searchParams.toString();
  const slug = `${VoiceApiEndpoints.calls}${query ? `?${query}` : ""}`;
  const url = buildVoiceUrl(slug);

  return fetchData<CallRow[]>(url, { method: "GET" });
}

export async function getCallMessages(
  callId: string,
  params: CallsListParams = {}
): Promise<CallMessageRow[]> {
  const searchParams = new URLSearchParams();

  if (typeof params.limit === "number") {
    searchParams.set("limit", String(params.limit));
  }

  if (typeof params.offset === "number") {
    searchParams.set("offset", String(params.offset));
  }

  const query = searchParams.toString();
  const slug = `${VoiceApiEndpoints.calls}/${callId}/messages${
    query ? `?${query}` : ""
  }`;
  const url = buildVoiceUrl(slug);

  return fetchData<CallMessageRow[]>(url, { method: "GET" });
}

export type OutboundCallPayload = {
  to: string;
  from?: string;
  medical_record_request_id: string;
  agent?: string;
  agent_type?: "openai_audio" | "deepgram_tts" | "deepgram_agent";
};

export async function createOutboundCall(
  payload: OutboundCallPayload
): Promise<unknown> {
  const url = buildVoiceUrl(VoiceApiEndpoints.outbound);
  return fetchData(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
